module.exports = __webpack_public_path__ + "static/media/bright.575f2819.jpg";